import React, { useState, useEffect } from 'react';
import { withCookies, Cookies, ReactCookieProps } from 'react-cookie';
import moment from 'moment';
import PopUpDC from 'PopUpDC';
import { Modal, Checkbox, Button } from 'antd';
import styled from 'styled-components';
import { Colors, SecondaryColor, PrimaryColor } from 'GlobalStyles';

interface ICookieProps extends ReactCookieProps {}

const FrameworkInfoModal = (props: ICookieProps) => {
  //props.cookies를 통해 쿠키에 접근
  const [cookies, setCookies] = useState<Cookies | undefined>(props.cookies);
  //쿠키 존재 여부
  const [hasCookies, setHasCookies] = useState<boolean>(false);
  //쿠키를 가지고 있지 않아야 true (열림)
  const [showModal, setShowModal] = useState(false);
  //antd checkbox checked 여부
  const [isChecked, setIsChecked] = useState<boolean>(false);

  //props.cookie 변경될경우 홈화면 랜더 될 때
  useEffect(() => {
    //cookies( === props.cookies) 값이 있으면
    //관련 value 값을 get 해오고
    if (cookies) {
      const currentCookies = cookies.get(PopUpDC.FRAMEWORK_INFO_COOKIE_VALUE);
      //값이 있으면 만료기한이 지나지 않았다는거니까 setShowModal(false); ==> reload 해도 모달 보이지 않게!!!
      setShowModal(!currentCookies);
      //쿠키 존재 여부
      setHasCookies(!!currentCookies);
    } else {
      setCookies(props.cookies);
    }
  }, [props.cookies]);

  //닫기 버튼을 누르면 closeModal() 아래 함수 실행
  const closeModal = () => {
    if (cookies) {
      if (isChecked) {
        const expires: Date = moment()
          .add(1, 'days')
          .toDate();
        //cookiesd의 set메서드 cookies.get(key, value,경로/만료일자 등)
        cookies.set(PopUpDC.FRAMEWORK_INFO_COOKIE_VALUE, true, {
          path: '/',
          expires,
        });
      }
    }
    setShowModal(false);
  };

  const removeCookies = () => {
    if (cookies) {
      cookies.remove(PopUpDC.FRAMEWORK_INFO_COOKIE_VALUE);
    }
  };

  //모달 닫기
  const onCloseModal = () => {
    // setShowModal(false);
    closeModal();
  };

  //하루동안 안보기 체크박스
  const onCheck = (e: any) => {
    setIsChecked(e.target.checked);
  };

  return showModal && cookies ? (
    <div>
      <Modal
        width={470}
        // zIndex={0}
        maskClosable={true}
        onCancel={onCloseModal}
        // zIndex={1500}
        // mask={false}
        closable={false}
        visible={showModal}
        className='landing-page-modal-container framework'
        title={
          <p className='modal-title'>
            Career Step 첫 방문자를 위한
            <br />
            <br />
            추천 컨텐츠
          </p>
        }
        footer={
          <Button onClick={onCloseModal} block>
            닫기
          </Button>
        }
      >
        <div className='modal-body'>
          <div className='modal-desciption'>
            <div className='modal-desciption-title' style={{ marginTop: '20px' }}>
              1. Career Step 오픈채팅방
            </div>
            <p>컨설팅 업계 트렌드, 현직자 Q&A, </p>
            <p>스터디원 구하기 등</p>
            <p>컨설팅 입사 준비에 꼭 필요한</p>
            <p>팁과 정보를 놓치지 마세요!</p>

            <br />
            <p style={{ textDecoration: 'underline' }}>
              <a
                className='modal-desciption_link'
                href='https://url.kr/u2iazw'
                target='_blank'
                rel='noopener noreferrer'
              >
                카카오톡 오픈채팅방 참여 신청
              </a>
            </p>
            <p className='modal-desciption-smalltext' style={{ color: '#747474' }}>
              (신청 시 카톡 링크와 코드 제공)
            </p>

            <div className='modal-desciption-title' style={{ marginTop: '40px' }}>
              <p>2. 전략컨설팅 인터뷰 </p>
              <p>MasterClass [기초편]</p>
              <p>온라인 강의가</p>
              <p>새롭게 출시되었어요</p>
            </div>
            <p>전략컨설팅 준비 Day1부터</p>
            <p>인터뷰 전까지 과정에서</p>
            <p>익혀야 할 모든 내용을 담은</p>
            <p>풀 패키지 VOD 강의입니다</p>
            <br />
            <p style={{ textDecoration: 'underline' }}>
              <a
                className='modal-desciption_link'
                href='/lectures/interview-master-class-basic'
                target='_blank'
                rel='noopener noreferrer'
              >
                자세히 알아보기
              </a>
            </p>

            <Checkbox className='checkbox-text' onChange={onCheck}>
              하루동안 보지 않기
            </Checkbox>
          </div>
        </div>
      </Modal>
    </div>
  ) : null;
};

export default withCookies(FrameworkInfoModal);
